import Api from "../utils/Api";
import { createParams } from "../utils/ProgUtil";
import * as types from "./Types";

export const getBasicStats = ({ period = "daily", statsPlatform = "all" } = {}) => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {
      period,
      stats_platform: statsPlatform,
    });
    return Api.get(`/admin_stats/basic_stats?${params}`);
  };
};

export const getRetentionModel = () => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin_stats/retention_model?${params}`);
  };
};

export const getStatsGraphs = () => {
  return (dispatch, getState) => {
    const state = getState();
    const params = createParams(state.login, {});
    return Api.get(`/admin_stats/stats_graphs?${params}`);
  };
};
